import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import 'vuetify/dist/vuetify.min.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import axios from 'axios';
import moment from 'moment';
import vuetify from './plugins/vuetify';
import './plugins/interceptors';
import VueEditableGrid from 'vue-editable-grid'
import 'vue-editable-grid/dist/VueEditableGrid.css'

Vue.component('vue-editable-grid', VueEditableGrid)
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$print = print;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
